import React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { Content, Flex, Heading, IllustratedMessage, Text, View, } from '@adobe/react-spectrum';
import Upload from '@spectrum-icons/illustrations/Upload';
import { handleImageFilesDrop } from 'app/stores/project/actions/create';
import { useAppDispatch } from 'app/stores/store';
import { useDropzone } from 'app/views/hooks/useDropzone';
import { analytics } from 'app/utils/analytics';
import { addActiveDragClass, removeActiveDragClass } from 'app/utils/dnd';
const DropSlide = () => {
    const multiSelectEnabled = configGet('multipleFilesSelectEnabled', false);
    const ctaText = multiSelectEnabled
        ? 'to add next slide'
        : 'to start new project';
    return (React.createElement(Flex, { position: "absolute", left: "0px", top: "0px", right: "0px", bottom: "0px", alignItems: "center", justifyContent: "center" },
        React.createElement(View, { padding: "size-500", backgroundColor: "gray-100", borderColor: "gray-200", borderWidth: "thick", borderRadius: "medium" },
            React.createElement(IllustratedMessage, null,
                React.createElement(Upload, null),
                React.createElement(Heading, { level: 6 }, "Drop your image"),
                React.createElement(Content, null,
                    React.createElement(Text, null, ctaText))))));
};
export function FileDrop(props) {
    const { children, className } = props;
    const dispatch = useAppDispatch();
    const activeController = useSelector((state) => state.editor.activeController);
    const dropEnabled = activeController === 'image-annotate';
    const variant = React.useRef(0);
    const { getRootProps, isDragActive, acceptedFiles, fileRejections } = useDropzone({
        preventDropOnDocument: false,
        disabled: !dropEnabled,
    });
    React.useEffect(() => {
        if (acceptedFiles.length) {
            analytics({
                action: 'FileDrop',
                label: 'window',
            });
            dispatch(handleImageFilesDrop({
                data: acceptedFiles,
                source: 'file',
            }));
        }
    }, [acceptedFiles, dispatch]);
    React.useEffect(() => {
        if (fileRejections.length) {
            // facade.uploadStore.rejectFiles(fileRejections);
        }
    }, [fileRejections]);
    React.useEffect(() => {
        if (isDragActive) {
            addActiveDragClass();
            variant.current = Math.trunc(Math.ceil(6 * Math.random()));
        }
        else {
            removeActiveDragClass();
        }
    }, [isDragActive]);
    // -----------------------
    // Render
    // -----------------------
    return (React.createElement("div", Object.assign({}, getRootProps({ className: clsx(className, 'drop-area') }), { style: {
            position: 'relative',
            height: '100%',
            width: '100%',
        } }),
        children,
        isDragActive && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "drop-area__overlay" }),
            React.createElement(DropSlide, null)))));
}
